module.exports = __webpack_public_path__ + "img/xw-002.ac344286.jpg";